import { getBrowserDocumentHiddenProp, getBrowserVisibilityPropEventType, } from "@domains/utils/browserVisibility";
import React from "react";
export function usePageVisibility() {
    const [isVisible, setIsVisible] = React.useState(getBrowserDocumentHiddenProp(document));
    const onVisibilityChange = () => setIsVisible(getBrowserDocumentHiddenProp(document));
    React.useEffect(() => {
        const visibilityChange = getBrowserVisibilityPropEventType(document);
        document.addEventListener(visibilityChange, onVisibilityChange);
        return () => {
            document.removeEventListener(visibilityChange, onVisibilityChange);
        };
    }, []);
    return isVisible;
}
